import { css } from 'styled-components';

export const ComponentClasses = css`
  /* Components general classes */
`;
